import {defineLordIconElement, LordIconElement} from 'lord-icon-element';
import lottie from 'lottie-web';
import { createHtmlElement, rgbaToHexA } from './functions';
import { isDesktopMode } from './modules/language/langSwitcher';

defineLordIconElement(lottie.loadAnimation);

const lordIcons = {
  search: '19-magnifier-zoom-search-outline-edited.json',
  gallery: '54-photo-picturellandscape-gallery-outline-edited.json',
  map: '18-location-pin-outline-edited.json',
  contactUs: '140-earphone-telephone-outline-edited.json',
  about: '425-exclamation-mark-bubble-outline-edited.json',
  '3dModel': '63-home-outline-edited.json',
  getApp: '1335-qr-code-outline-edited.json',
  scanIcon: '1686-scan-qr-code-outline-edited.json',
  lang: '27-globe-outline-edited.json',
  soundOn: '191-speaker-outline-edited.json',
  soundOff: '192-speaker-off-on-morph-outline-edited.json',
  rotate: '250-smartphone-rotate-morph-outline-edited.json',
  play: '830-plane-2-outline-edited.json',
  compare: '1409-compare-outline-edited.json',
  onBoardingSwipe: '1444-swipe-left-right-outline-edited.json',
  '360View': '1434-360-view-outline-edited.json',
  '360': '1434-360-view-outline-edited.json',
  '2D': '731-real-estate-building-project-outline-edited.json',
  vantage: '741-binoculars-telescope-outline-edited.json',
  print: '732-printer-outline-edited.json',
  favorite: '1453-card-heart-outline-edited.json',
  clouds: '801-two-clouds-outline-edited.json',
  rain: '808-heavy-rain-outline-edited.json',
  thunderstorm: '808-heavy-rain-outline-edited.json',
  snow: '815-snow-flake-outline-edited.json',
  drizzle: '807-mild-rain-outline-edited.json',
  celsius: '823-celsius-temperature-outline-edited.json',
};

const lordIconsGlobalSettings = {
  trigger: 'loop',
  delay: '2000',
  stroke: '100'
};

let primaryColor = null;
let secondaryColor = null;
let activeColor = null;

export function getLordIconColors () {
  const {primary,secondary} = config.features.icons.color;

  const primaryRgba = config.style.colors.find(color => color.key === primary) || { value: '255,255,255,1' };
  const secondaryRgba = config.style.colors.find(color => color.key === secondary) || { value: '255,255,255,1' };
  const activeRgba = config.style.colors.find(color => color.key === 'brand2');

  primaryColor = rgbaToHexA(primaryRgba.value.split(','),false);
  secondaryColor = rgbaToHexA(secondaryRgba.value.split(','),false);
  activeColor = rgbaToHexA(activeRgba.value.split(','), false);
}

export function setLordIcon (name,parentContainer,parameters = {},position, isActive = false) {
  const iconsPath = './img/lordIcons/';
  const lordIcon = lordIcons[name];

  if (!parentContainer || !lordIcon){
    return;
  }

  let icon;
  icon = createHtmlElement('','','lord-icon',['lord__icon']);
  icon.setAttribute('src',iconsPath + lordIcon);
  icon.setAttribute('data-menu-item',name);
  icon.setAttribute('target',parentContainer.tagName);
  icon.setAttribute('activeIcon', false);
  parentContainer.setAttribute('lord-icon-name',name);

  Object.entries(lordIconsGlobalSettings).forEach(([key,value]) =>{
    icon.setAttribute(key,value);
  });

  // if (Object.keys(parameters).length){
  //
  //   Object.entries(parameters).forEach(([key,value]) =>{
  //     icon.setAttribute(key,value);
  //   });
  //
  // }

  // const {primary,secondary} = config.features.icons.color;
  //
  // const primaryRgba = config.style.colors.find(color => color.key === primary) || { value: '255,255,255,1' };
  // const secondaryRgba = config.style.colors.find(color => color.key === secondary) || { value: '255,255,255,1' };
  //
  // const primaryColor = rgbaToHexA(primaryRgba.value.split(','),false);
  // const secondaryColor = rgbaToHexA(secondaryRgba.value.split(','),false);
  icon.setAttribute('colors',`primary:${primaryColor || parameters.primaryColor},secondary:${secondaryColor || parameters.secondaryColor}`);

  if (isActive) {
    icon.setAttribute('activeIcon', true);
    icon.setAttribute('colors',`primary:${activeColor},secondary:${activeColor}`);
  }

  if (Object.keys(parameters).length){

    Object.entries(parameters).forEach(([key,value]) =>{
      icon.setAttribute(key,value);
    });

  }

  if (position){
    parentContainer.insertAdjacentElement(position,icon);
  } else {
    parentContainer.appendChild(icon);
  }

  return icon;
}

export function setActiveLordIcon (name,parentContainer) {
  const activeIcon = getLordIcon(undefined,parentContainer);
  activeIcon && toggleIconParams(activeIcon);

  if (name === 'search' && isDesktopMode()){
    return;
  }

  const icon = getLordIcon(name,parentContainer);
  icon && toggleIconParams(icon);
}

function getLordIcon (name,parentContainer) {
  if (name){
    return parentContainer.querySelector(`lord-icon[data-menu-item="${name}"]`);
  } else {
    return parentContainer.querySelector('lord-icon[activeIcon="true"]');
  }
}

function toggleIconParams (icon) {

  switch (icon.getAttribute('activeIcon')) {

    case 'true':
      icon.setAttribute('colors',`primary:${primaryColor},secondary:${secondaryColor}`);
      icon.setAttribute('activeIcon',false);
      break;

    case 'false':
      icon.setAttribute('colors',`primary:${activeColor},secondary:${activeColor}`);
      icon.setAttribute('activeIcon',true);
      break;
  }
}
